import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Layout';
import PostPreview from '../components/PostPreview';

const IndexPage = ({ data }) => (
  <Layout>
    {data.allMarkdownRemark.edges.map(({ node }) => {
      if (!node.fields.slug.includes('/drafts')) {
        return <PostPreview data={node} key={node.id} />
      }
      return null
    })}

  </Layout>
);

export default IndexPage;

export const query = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            tags
            title
            date(formatString: "DD MMMM, YYYY", locale:"pt-br")
            description
          }
          fields {
            slug
          }
          excerpt(pruneLength: 290)
        }
      }
    }
  }
`;
